import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Container, Icon, Header, Button } from "semantic-ui-react";
import { AppStoreContext } from "../stores/AppStore";
import {useTranslation} from "react-i18next";
import { resumeStore } from "../stores/ResumeStore";
import "./ThankYou.css";

export default observer(function ThankYou() {
  const appStore = useContext(AppStoreContext);
  const [t] = useTranslation();
  let header;
  let body;
  if (!!appStore.reminderDateUTC) {
    header = t("reminder_response_header");
  } else {
    header = t("thank_you_applied");
  }
  if (!!resumeStore.linkedInProfileUrl && !appStore.useLeadsOnboardingToken) {
    // LinkedIn is harvesting
    body = (
      <div className="thank-you-body-after-steps">
        <div>
          <div className="thank-you-after-steps-icon">
            <svg width="83px" height="83px" viewBox="0 0 83 83" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="New-Workflow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="CM-Onboarding---Register-Email-9" transform="translate(-326.000000, -204.000000)" stroke="#231F20" strokeWidth="2">
                      <g id="Group" transform="translate(327.000000, 205.000000)">
                          <polyline id="Stroke-3455" strokeLinejoin="round" points="34.8091433 72.4339823 -0.00027607899 72.4339823 -0.00027607899 0.645817376 38.6507825 0.645817376 55.2155219 17.212317 55.2155219 31.9772097"></polyline>
                          <polyline id="Stroke-3456" strokeLinecap="round" strokeLinejoin="round" points="38.6510586 0.645817376 38.6510586 17.212317 55.2157979 17.212317"></polyline>
                          <path d="M73.1609323,57.2492668 C73.1609323,64.8753788 66.9781433,71.0546831 59.3597436,71.0546831 C51.7330615,71.0546831 45.5530333,64.8753788 45.5530333,57.2492668 C45.5530333,49.6217743 51.7330615,43.4424699 59.3597436,43.4424699 C66.9781433,43.4424699 73.1609323,49.6217743 73.1609323,57.2492668 L73.1609323,57.2492668 Z" id="Stroke-3457"></path>
                          <line x1="67.6353493" y1="68.2882158" x2="80.063045" y2="80.7172321" id="Stroke-3458" strokeLinecap="round"></line>
                      </g>
                  </g>
              </g>
            </svg>
          </div>
          <div className="thank-you-body-after-steps-num">1</div>
          <p>{t("thank_you_linkedin_step_1")}</p>
        </div>
        <div>
          <div className="thank-you-after-steps-icon">
            <svg width="83px" height="83px" viewBox="0 0 91 91" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="New-Workflow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="CM-Onboarding---Register-Email-9" transform="translate(-554.000000, -200.000000)" stroke="#231F20" strokeWidth="2">
                      <g id="Stroke-2464-+-Stroke-2465-+-Stroke-2466" transform="translate(555.000000, 201.000000)">
                          <polyline id="Stroke-2464" strokeLinecap="round" points="80 64 68 76 62 68.5"></polyline>
                          <path d="M89,70.5 C89,80.7181667 80.7150833,89 70.5,89 C60.2818333,89 52,80.7181667 52,70.5 C52,60.283375 60.2818333,52 70.5,52 C80.7150833,52 89,60.283375 89,70.5 L89,70.5 Z" id="Stroke-2465"></path>
                          <path d="M52,49.6926683 C48.998557,48.6936735 46.1624996,47.4973464 42.8777572,46.2501445 L42.8777572,37.0001927 C42.8777572,37.0001927 48.2711665,34.2467904 48.2711665,24.9922136 C51.2909857,24.9922136 51.2909857,16.9385889 48.2711665,16.9385889 C48.2711665,16.0305519 51.4701534,10.6917881 50.2006655,5.55343983 C48.3722355,-1.85114661 26.9287628,-1.85114661 25.1003328,5.55343983 C15.9535884,3.7019078 21.2398033,15.9765939 21.2398033,17.2176291 C18.2153901,17.2176291 18.2153901,24.9922136 21.2398033,24.9922136 C21.2398033,34.2467904 27.5642725,38.5418513 27.5642725,38.5418513 L27.5642725,46.2501445 C16.8356451,50.3540398 3.52210148,53.1999417 1.93103042,58.0376665 C0.0995376506,63.5922625 0,74 0,74 L39.8150602,74" id="Stroke-2466" strokeLinejoin="round"></path>
                      </g>
                  </g>
              </g>
            </svg>
          </div>
          <div className="thank-you-body-after-steps-num">2</div>
          <p>{t("thank_you_linkedin_step_2")}</p>
        </div>
        <div className="last">
          <div className="thank-you-after-steps-icon">
            <svg width="78px" height="53px" viewBox="0 0 83 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="New-Workflow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
                  <g id="CM-Onboarding---Register-Email-9" transform="translate(-790.000000, -218.000000)" stroke="#231F20" strokeWidth="2">
                      <g id="Stroke-3705-+-Stroke-3706" transform="translate(791.000000, 219.000000)">
                          <path d="M81,46.5 C81,50.6745 77.673,54 73.5,54 L7.239,54 C3,54 0,50.6745 0,46.5 L0,7.5 C0,3 3,0 7.5,0 L73.5,0 C78,0 81,3 81,7.5 L81,46.5 L81,46.5 Z" id="Stroke-3705" strokeLinecap="round"></path>
                          <polyline id="Stroke-3706" points="79 1 42.0001753 31 2 1"></polyline>
                      </g>
                  </g>
              </g>
            </svg>
          </div>
          <div className="thank-you-body-after-steps-num">3</div> 
          <p>{t("thank_you_linkedin_step_3")}</p>
        </div>
      </div>
    );
  } else if (!!appStore.reminderDateUTC) {
    // requested reminder
    body = (
      <div style={{ display: "inline-block", maxWidth: 400 }}>
        {t("reminder_response_body")}
      </div>
    );
  } else {
    // generic thank you
    body = (
      <div style={{ display: "inline-block", maxWidth: 400 }}>
        {t("be_in_touch")}
      </div>
    );
  }

  return (
    <div className="view">
      <Container textAlign="center" fluid style={{ paddingTop: "2rem" }}>
        <Header as="h2" className="thank-you-heading">
          <Header.Content><Icon name="check circle" size="large" color="green" />{header}</Header.Content>
        </Header>
        <br />
        {body}
        <br />
        <br />
        <br />
        <br />
        {
          !appStore.hasTNC && (
            <Button onClick={() => appStore.goToRedirector()} primary>
              <span dangerouslySetInnerHTML={{ __html: t("begin_tutorial") }} />
            </Button>
          )
        }
      </Container>
    </div>
  );
});
